<!-- 推荐 -->
<template>
  <div class="recommend">
    <div class="tj-item" @click="navDetails">
      <div class="tj-left">
        <div class="tj-title">
          <!-- {{item.title}} -->

          <slot name="title"></slot>
        </div>

        <div class="tj-footer">
          <slot name="author"></slot>

          <slot name="time"></slot>
        </div>
      </div>

      <div class="tj-img">
        <slot name="img"></slot>

        <slot name="player"></slot>
      </div>
    </div>

    <img
      src="../../assets/img/home/top.png"
      class="top"
      @click="backTop"
      v-show="show"
    />
  </div>
</template>

<script>
import { getArticle } from "@/api/apiData";
export default {
  props: {
    item: {
      type: Object,
    },
  },
  components: {},
  data() {
    return {
      // page: 0, //当前页码
      // offset: 10, //当前页面条目数
      // totalPages: 1, //总页码
      // list: [], //文章数组
      // loading: false,
      // finished: false,
      // refreshing: false,
      show: false,
    };
  },
  computed: {},
  methods: {
    // 显示图标
    handleScroll() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 1000) {
        that.show = true;
      }
      if (scrollTop == 0) {
        that.show = false;
      }
    },
    // 回到顶部
    backTop() {
      var that = this;
      var timer = setInterval(function () {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        if (osTop === 0) {
          that.show = false;
          clearInterval(timer);
        }
      }, 30);
    },
    // 详情跳转
    navDetails() {
      var item = this.item;
      var url = item.url;
      var type = item.type;
      var id = item.article_id;

      if (url != "") {
        window.location.href = url;
      } else {
        if (type == 1) {
          this.$router.push({
            name: "Artcomponent",
            query: {
              id: id,
            },
          });
        } else {
          if (this.$route.name == "Ideology") {
            this.$router.push({
              path: "/ideology/article/videoDetails",
              query: {
                id: id,
              },
            });
          } else {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            this.$router.replace({
              path: "/ideology/article/videoDetails",
              query: {
                id: id,
              },
            });
          }
        }
      }
    },
    // // 上拉记载
    // onLoad() {
    //   this.getList();
    // },
    // // 下拉刷新
    // onRefresh() {
    //   var that = this;
    //   that.list = [];
    //   that.page = 0;
    //   that.offset = 10;
    //   that.totalPages = 1;
    //   that.loading = false;
    //   that.finished = false;
    //   setTimeout(() => {
    //     that.refreshing = false;
    //   }, 1500);
    // },
    // // 获取文章列表
    // getList() {
    //   var that = this;
    //   var page = that.page + 1;
    //   var list = that.list;
    //   var totalPages = that.totalPages;
    //   var offset = that.offset;
    //   var channel_id = that.kindsId;
    //   // 参数
    //   let obj = {
    //     page: page,
    //     offset: offset,
    //     channel_id: channel_id
    //   };
    //   if (totalPages >= page) {
    //     getArticle(obj).then(res => {
    //       //(res);

    //       if (res.code == 1) {
    //         that.page = page;
    //         that.list = list.concat(res.data.list);
    //         that.totalPages = Math.ceil(
    //           Number(res.data.total) / res.data.length
    //         );
    //         if (res.data.list.length == 0) {
    //           //数据请求成功 但是无数据
    //           that.finished = true;
    //           that.loading = false;
    //           return false;
    //         }
    //         if (that.list.length > list.length) {
    //           // 数据请求成功后  停止加载状态
    //           setTimeout(() => {
    //             that.loading = false;
    //           }, 1500);
    //         }
    //       }
    //     });
    //   } else {
    //     // 全部数据加载完毕
    //     that.finished = true;
    //   }
    // }
  },
  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    document.removeEventListener("scroll", this.handleScroll);
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
};
</script>
<style lang='less' scoped>
.recommend {
  font-size: 0.3rem;
  padding: 0 0.32rem;
  .tj-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.28rem 0;
    border-bottom: 0.01rem solid rgba(178, 178, 178, 0.5);
    .tj-left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 70%;
      height: 1.5rem;
      .tj-title {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        font-weight: bold;
        line-height: 0.42rem;
        color: rgba(51, 51, 51, 1);
      }
      .tj-footer {
        display: flex;
        align-items: center;
        span {
          font-size: 0.26rem;
          font-weight: 400;
          line-height: 0.4rem;
          height: 0.4rem;
        }
        span:nth-child(1) {
          overflow: hidden;
          color: rgba(75, 183, 255, 1);
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          max-width: 60%;
        }
        span:last-child {
          color: rgba(128, 128, 128, 1);
          margin-left: 0.2rem;
        }
      }
    }
    .tj-img {
      position: relative;
      .tj-player {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 2;
        width: 0.6rem;
        height: 0.6rem;
        border-radius: 50%;
      }
      .tj-right {
        width: 1.8rem;
        height: 1.5rem;
        border-radius: 0.08rem;
      }
    }
  }
  .top {
    width: 1rem;
    height: 1rem;
    position: fixed;
    right: 0.3rem;
    bottom: 20%;
    z-index: 100;
    background: #fff;
    border-radius: 50%;
    box-shadow: 0rem 0.05rem 0.1rem rgba(255, 255, 255, 0.1);
  }
}
</style>